import React from 'react'
import SvgLogo from '#/assets/images/logos/logo-hexa.svg'

export default function Intro() {
  return (
    <div className='relative mx-auto max-w-7xl px-4 pt-10 sm:px-6 lg:px-8'>
      <div className='relative'>
        <div className='mx-auto max-w-4xl text-center text-lg font-thin tracking-tight text-gray-500 sm:px-5 '>
          <p>
            For far too long,
            {' '}
            <strong>real estate professionals</strong>
            {' '}
            have had to
            piece together the
            <br />
            information clients need to purchase or sell a home with outdated
            tools.
          </p>

          <div className='mt-8 text-center text-lg tracking-wide'>
            Resulting in
            <span className='tracking-widest'>...</span>
          </div>
        </div>
        <blockquote className='my-8 px-10 sm:px-0'>
          <div className='flex flex-col space-y-3 rounded-3xl pb-2 sm:flex-row sm:space-x-8 sm:space-y-0 lg:justify-center'>
            <div className='flex items-center'>
              <div className='h-2 w-2 rounded-full bg-primary' />
              <p className='ml-2 font-light text-gray-500 sm:text-base'>
                Lack of client trust and confidence
              </p>
            </div>
            <div className='flex items-center'>
              <div className='h-2 w-2 rounded-full bg-primary' />

              <p className='ml-2 font-light text-gray-500 sm:text-base'>
                Lost buyers
              </p>
            </div>
            <div className='flex items-center'>
              <div className='h-2 w-2 rounded-full bg-primary' />

              <p className='ml-2 font-light text-gray-500 sm:text-base'>
                Lost sellers
              </p>
            </div>
            <div className='flex items-center'>
              <div className='h-2 w-2 rounded-full bg-primary' />

              <p className='ml-2 font-light text-gray-500 sm:text-base'>
                Wasted time
              </p>
            </div>
          </div>
        </blockquote>
        <div className='mx-auto max-w-7xl pb-12 sm:px-6'>
          <div className='text-center'>
            <h1 className='text-2xl font-light tracking-tighter text-gray-900 sm:tracking-tight md:text-3xl'>
              <span className='block'>TopHap Has Changed That Forever</span>
            </h1>
            <p className='mx-auto mt-3 max-w-lg text-base font-light text-gray-500 sm:max-w-md sm:text-base md:mt-5 md:max-w-3xl md:text-base'>
              Our visual data and analytics platform gives you
              access to the most powerful data-driven tools to analyze
              properties, neighborhoods, and regions like never before.
              With the power of data at your fingertips, you can position
              yourself as a true expert in any market, help your clients make
              data-driven decisions, and win more business.
            </p>
          </div>
        </div>
      </div>
      <div className='-mb-16 text-center'>
        <SvgLogo className='h-14 w-14' />
      </div>
    </div>
  )
}
